import { Store } from 'vuex';
import { BaseState } from './getStore/types';
import { Module } from 'vuex';
export default {
    register<T>(store: Store<BaseState>, Module: T, name: string): void {
        if (!(store && store.state && store.state[name])) {
            store.registerModule(name, Module as Module<unknown, BaseState>);
        } else {
            // re-use the already existing module
            console.log(`reusing module: ${name}`);
        }
    },
};